import React, { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api';
import { useAuth } from '../context/AuthContext';
import { mountEditor } from '../floorplan/editor';

const FloorPlanEditor = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const canEdit = user?.role === 'admin';
  const hostRef = useRef(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let editor = null, scanUrl = null, cancelled = false;
    const start = async () => {
      try {
        const res = await api.get(`/api/floorplans/${id}`);
        const row = res.data;
        if (row.has_scan) {
          try {
            const img = await api.get(`/api/floorplans/${id}/scan`, { responseType: 'blob' });
            scanUrl = URL.createObjectURL(img.data);
          } catch (err) { /* the plan still opens without its drawing */ }
        }
        if (cancelled || !hostRef.current) return;
        setLoading(false);
        const plan = row.data && Object.keys(row.data).length ? row.data : {};
        plan.meta = { project: row.name, client: row.client || '', site: row.site || '', ...(plan.meta || {}) };
        editor = mountEditor(hostRef.current, {
          plan,
          scanUrl,
          canEdit,
          draftKey: `cw-fp-draft-${id}`,
          baseStamp: row.updated_at,
          onBack: () => {
            if (editor && editor.isDirty() && !window.confirm('You have changes that are not saved yet. Leave anyway?')) return;
            navigate('/floor-plans');
          },
          onSave: async (data, base) => {
            try {
              const r = await api.put(`/api/floorplans/${id}`, {
                name: data.meta?.project || row.name, client: data.meta?.client, site: data.meta?.site, data, base_updated_at: base,
              });
              return { stamp: r.data.updated_at };
            } catch (err) {
              const e = new Error(err.response?.data?.error || 'Save failed');
              e.status = err.response?.status;
              throw e;
            }
          },
        });
      } catch (err) {
        if (!cancelled) { setLoading(false); setError(err.response?.status === 404 ? 'That floor plan does not exist.' : 'Could not open the floor plan.'); }
      }
    };
    start();
    return () => {
      cancelled = true;
      if (editor) editor.destroy();
      if (scanUrl) URL.revokeObjectURL(scanUrl);
    };
  }, [id, canEdit, navigate]);

  return (
    <div>
      {loading && <div className="loader">Opening plan...</div>}
      {error && (
        <div>
          <div className="alert alert-error">{error}</div>
          <button className="btn btn-outline" onClick={() => navigate('/floor-plans')}>Back to Floor Plans</button>
        </div>
      )}
      <div ref={hostRef} />
    </div>
  );
};

export default FloorPlanEditor;
